import { z } from "zod"

export const setExplorerLayerFormSchema = z.object({
  cod_plano: z.string(),
  id_user: z.number(),
  id_layer: z.number()
})

export type setExplorerLayerFormData = z.infer<typeof setExplorerLayerFormSchema>